/* eslint-disable react/function-component-definition */
import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from './View.Style';
import investorsImg from '../../imgs/investors.svg';
import pledgedIcon from '../../imgs/pledged.svg';
import investment from '../../imgs/investment.svg';
import visitImg from 'img/visits.png'
import { ButtonLink } from 'components'
import i18n from 'support/i18n';

function SummaryCard({
  classes,
  userInvestmentsMap,
  ideaOwnerName,
  pledged,
  goal,
  userEmail,
  businessUnit,
  market,
  submitterName,
  submitterEmail,
  createdDate,
  onClickUserProfile,
  MyIdeaView,
  CategoryName,
  ownerEmail,
  onIdeaOwnerUserClick,
  ownerPhoto,
  isHackathonEnable
}) {

  const ownInvestment = userInvestmentsMap?.[userEmail] || 0;

  const percentageRaised = useMemo(() => {
    const percent = Math.round((pledged / goal) * 100);
    return Number.isNaN(percent) ? 0 : Math.min(percent, 100);
  }, [pledged, goal]);

  const formattedDate = useMemo(() => {
    if (!createdDate) return '';
    const date = new Date(createdDate);
    const day = date.getDate();
    const suffix = ['th', 'st', 'nd', 'rd'][(day % 10 > 3 || (day > 10 && day < 20)) ? 0 : day % 10] || 'th';
    const formatted = new Intl.DateTimeFormat('en-US', {
      month: 'long',
      year: 'numeric'
    }).format(date);
    return `${day}${suffix} ${formatted}`;
  }, [createdDate]);

  return (
    <div className={classes.container}>
      <span className={classes.titles}>
        <div className={classes.detailsContainer} style={{ borderRight: '1px solid #EBEBEB' }}>
          <div className={classes.header}>Idea Owner</div>
          <div className={classes.detailsContainer}>
            <img 
              className={classes.icon} 
              src={ownerPhoto || investorsImg} 
              alt="investors" 
            />
            <ButtonLink
                onLinkClick={() => onIdeaOwnerUserClick(ownerEmail)}
                className
              >
              <span className={classes.big_number}>{ideaOwnerName}</span>
            </ButtonLink>
          </div>
        </div>

        <div className={classes.detailsContainer} style={{ borderRight: '1px solid #EBEBEB' }}>
          <div className={classes.header}>Category</div>
          <div className={classes.detailsContainer}>
            <img className={classes.icon} src={pledgedIcon} alt="Category" />
            <div className={classes.big_number}>{CategoryName}</div>
            
          </div>
        </div>

        <div className={classes.detailsContainer}>
          <div className={classes.header}>Idea View</div>
          <img className={classes.icon} src={visitImg} alt=" MyIdeaView" />
          <div className={classes.big_number}>{MyIdeaView}</div>
        </div>
      </span>


      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div className={classes.progressBar}>
          <div
            style={{
              backgroundColor: '#6D45FF',
              width: `${percentageRaised}%`,
              height: '100%'
            }}
          />
        </div>
      </div>


      <div className={classes.submittedBy}>
      Market &nbsp;
        <span className={classes.bold}>{market || 'Not Available'}</span>
      </div>

      <div className={classes.submittedBy}>
      Business Unit &nbsp;
        <span className={classes.bold}>{businessUnit || 'Not Available'}</span>
      </div>

      <div className={classes.submittedBy}>
      Submitted on &nbsp;
       {/* (
          
            <span className={classes.bold}>
              <button type="button" className={classes.btnBlank} onClick={() => onClickUserProfile(submitterEmail)}>
                {submitterName}
              </button>
            </span>
            &nbsp;on&nbsp;
          
        ) */}
        <span className={classes.bold}>{formattedDate}</span>
      </div>
    </div>
  );
}


export default memo(withStyles(styles)(SummaryCard));
